import { render, staticRenderFns } from "./CreateRestaurantN.vue?vue&type=template&id=788ae3cc"
import script from "./CreateRestaurantN.vue?vue&type=script&lang=js"
export * from "./CreateRestaurantN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports